export default function queryStringArray(array = [], arrayName = "includes") {
  return array.reduce((result, arrayItem) => {
    return (
      result + (result === "" ? "?&" : "&") + `${arrayName}[]=${arrayItem}`
    );
  }, "");
}
